import React from "react";

type UseCommunicationsMutationRefreshParams = {
  refreshCommunicationsNumberState: () => Promise<void>;
  loadUsageSummary: (startDate: string, endDate: string) => Promise<void>;
  refreshCallsList: () => Promise<void>;
  usageStartDate: string;
  usageEndDate: string;
};

export const useCommunicationsMutationRefresh = ({
  refreshCommunicationsNumberState,
  loadUsageSummary,
  refreshCallsList,
  usageStartDate,
  usageEndDate,
}: UseCommunicationsMutationRefreshParams) => {
  const refreshAfterNumberMutation = React.useCallback(async () => {
    await Promise.allSettled([
      refreshCommunicationsNumberState(),
      loadUsageSummary(usageStartDate, usageEndDate),
      refreshCallsList(),
    ]);
  }, [
    loadUsageSummary,
    refreshCallsList,
    refreshCommunicationsNumberState,
    usageEndDate,
    usageStartDate,
  ]);

  return {
    refreshAfterNumberMutation,
  };
};
